<template>
  <v-dialog v-model="active" width="480" persistent v-if="calibre">
    <v-card color="primary" class="ui-module-card rounded-sm">
      <v-card-title class="ui-module-titlebar">
        <div class="text-h6">Historial de movimiento</div>
        <v-spacer></v-spacer>
        <v-btn icon color="error" @click="closeDialog()"><v-icon>mdi-window-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="6" align="center">
              <v-card color="secondary" class="ui-stat-card">
                <v-card-title class="justify-center">
                  <div v-if="municionesDisponibles.length > 0" class="text-h6 primary--text">
                    {{ municionesDisponibles[0].disponibles }}
                  </div>
                  <div v-else class="text-h6 primary--text">0</div>
                  <div class="text-subtitle-2 primary--text">Municiones disponibles</div>
                </v-card-title>
              </v-card>
            </v-col>
            <v-col cols="6" align="center">
              <v-card color="secondary" class="ui-stat-card">
                <v-card-title class="justify-center">
                  <div v-if="cargadoresDisponibles.length > 0" class="text-h6 primary--text">
                    {{ cargadoresDisponibles[0].disponibles }}
                  </div>
                  <div v-else class="text-h6 primary--text">0</div>
                  <div class="text-subtitle-2 primary--text">Cargadores disponibles</div>
                </v-card-title>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-select
                class="ui-form-field"
                label="Mostrar movimientos de"
                v-model="selectedTipoLista"
                :items="tipoListaMovimientos"
                rounded
                filled
                dense
                color="secondary"
                background-color="transparent"
                item-color="secondary"
                item-value="id"
                item-text="title"
              ></v-select>
              <v-virtual-scroll height="480" :items="filteredListaMovimientos" item-height="88">
                <template v-slot:default="{ item, index }">
                  <v-list-item :key="index" three-line link>
                    <v-list-item-content>
                      <v-list-item-subtitle>{{ item.fecha }}</v-list-item-subtitle>
                      <v-list-item-title>{{ getTipoMovimiento(item.fk_idcatTipoMovimiento) }}</v-list-item-title>
                      <v-list-item-subtitle>{{ item.observaciones }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-avatar color="secondary">
                        <span class="white--text">{{ item.cantidad }}</span>
                      </v-avatar>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-virtual-scroll>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    active: {
      type: Boolean,
    },

    calibre: {
      type: Object,
    },
  },

  data() {
    return {
      selectedTipoLista: 1,
      tipoListaMovimientos: [
        { id: 1, title: 'Todos' },
        { id: 2, title: 'Cargadores' },
        { id: 3, title: 'Municiones' },
      ],
    }
  },

  computed: {
    ...mapGetters('movimientoMunicion', {
      movimientoMunicion: 'getMovimientoMunicion',
      municionesDisponibles: 'getMovimientoMunicionDisponibles',
    }),

    ...mapGetters('movimientoCargador', {
      movimientoCargador: 'getMovimientoCargador',
      cargadoresDisponibles: 'getMovimientoCargadorDisponibles',
    }),

    filteredMovimientoMuniciones() {
      return this.movimientoMunicion.filter((movimiento) => {
        return movimiento.fk_idCatCalibre == this.calibre.idCalibre
      })
    },

    filteredListaMovimientos() {
      switch (this.selectedTipoLista) {
        case 1:
          return _.sortBy(this.filteredMovimientoMuniciones.concat(this.movimientoCargador), function (movimiento) {
            return new Date(movimiento.fecha)
          }).reverse()
          break
        case 2:
          return _.sortBy(this.movimientoCargador, function (movimiento) {
            return new Date(movimiento.fecha)
          }).reverse()
          break
        case 3:
          return _.sortBy(this.filteredMovimientoMuniciones, function (movimiento) {
            return new Date(movimiento.fecha)
          }).reverse()
          break
        default:
          break
      }
    },
  },

  methods: {
    closeDialog() {
      this.$emit('close')
    },

    getTipoMovimiento(id_tipo_movimiento) {
      if (id_tipo_movimiento == 1) {
        return 'Entrada'
      } else return 'Salida'
    },
  },
}
</script>

<style scoped>
.ui-module-card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.ui-stat-card {
  border-radius: 12px;
}

::v-deep .ui-module-titlebar {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label {
  color: #a29bfe !important;
}
</style>
